import pLimit from "p-limit"
import { AttachmentsUploadResponse } from "../../types/Upload/AttachmentResponse"
import { BlockBlobClient } from "@azure/storage-blob"
import { BlockBlobParallelUploadOptions } from "@azure/storage-blob"


export const uploadImages = async (responseData: AttachmentsUploadResponse[], blobs: Blob[]) => {
	const limit = pLimit(5) // Limit concurrent uploads to 5
	const uploadTasks = blobs.map((blob, index) => {
		const blockBlobClient = new BlockBlobClient(
			`${responseData[index].uploadUri}${responseData[index].sasToken}`
		)

		const options: BlockBlobParallelUploadOptions = {
			blobHTTPHeaders: { blobContentType: blob.type }
		}

		return limit(() => blockBlobClient.uploadData(blob, options))
	})

	await Promise.all(uploadTasks)
}

export const getBlobs = async (attachments: AttachmentsUploadResponse[]) => {
	const limit = pLimit(5) // Limit concurrent downloads to 5
	const downloadTasks = attachments.map(attachment => {
		return limit(async () => {
			const response = await fetch(`${attachment.uploadUri}${attachment.sasToken}`)
			if (!response.ok) {
				throw new Error(`Failed to fetch attachment: ${response.statusText}`)
			}
			return response.blob()
		})
	})

	const blobs = await Promise.all(downloadTasks)
	return blobs
}